/* Offer / buy box: radio-group plan cards (click, Space/Enter, arrow keys), in-place updates (selected card expands,
   ATC label, trust-row refill text, one-time link, hidden form inputs), ?plan=90|60|30 deep link, ADD TO CART and the
   one-time link both call SMCart.addOffer (replace-not-stack). Optional sticky ATC. No prices are hard-coded here:
   every number comes from data attributes rendered by Liquid from Shopify data. */
(() => {
  const PLAN_PARAM = { '90': '12w', '60': '8w', '30': '4w' };

  const setBrText = (el, text) => {
    el.textContent = '';
    String(text || '').split('[br]').forEach((part, i) => {
      if (i) el.appendChild(document.createElement('br'));
      el.appendChild(document.createTextNode(part));
    });
  };

  const init = (root) => {
    if (root.dataset.smOfferReady) return;
    root.dataset.smOfferReady = '1';
    const cards = [...root.querySelectorAll('.plan[role="radio"]')];
    if (!cards.length) return;
    const form = root.querySelector('[data-sm-offer-form]');
    const atc = root.querySelector('[data-sm-atc]');
    const qtyInput = root.querySelector('[data-sm-qty]');
    const planInput = root.querySelector('[data-sm-plan]');
    const otp = root.querySelector('[data-sm-otp]');
    const refill = root.querySelector('[data-sm-refill]');
    const status = root.querySelector('[data-sm-offer-status]');
    const section = root.closest('.shopify-section') || document;
    const sticky = document.querySelector('[data-sm-sticky-atc]');
    let current = cards.find((c) => c.classList.contains('selected')) || cards[0];

    const paintAtc = (scope, card) => {
      scope.querySelectorAll('[data-sm-atc-price]').forEach((n) => { n.textContent = card.dataset.atcPrice; });
      scope.querySelectorAll('[data-sm-atc-compare]').forEach((n) => { n.textContent = card.dataset.atcCompare; });
    };

    const select = (card, { focus = false, silent = false } = {}) => {
      if (!card) return;
      current = card;
      cards.forEach((c) => {
        const on = c === card;
        c.classList.toggle('selected', on);
        c.setAttribute('aria-checked', on ? 'true' : 'false');
        c.tabIndex = on ? 0 : -1;
        const exp = c.querySelector('.exp-wrap');
        if (exp) exp.inert = !on;
      });
      paintAtc(root, card);
      if (sticky) paintAtc(sticky, card);
      if (qtyInput) qtyInput.value = card.dataset.bags;
      if (planInput) planInput.value = card.dataset.sellingPlan;
      if (refill) setBrText(refill, card.dataset.refillLabel);
      if (otp) {
        otp.textContent = card.dataset.otpLabel;
        const url = new URL(otp.getAttribute('href'), window.location.origin);
        url.searchParams.set('quantity', card.dataset.bags);
        otp.setAttribute('href', url.pathname + url.search);
      }
      if (focus) card.focus();
      if (!silent) document.dispatchEvent(new CustomEvent('sm:offer:select', { detail: { plan: card.dataset.planKey, bags: +card.dataset.bags } }));
    };

    cards.forEach((card) => {
      card.addEventListener('click', () => select(card));
      card.addEventListener('keydown', (e) => {
        const i = cards.indexOf(card);
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); select(card); }
        else if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); select(cards[(i + 1) % cards.length], { focus: true }); }
        else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); select(cards[(i - 1 + cards.length) % cards.length], { focus: true }); }
        else if (e.key === 'Home') { e.preventDefault(); select(cards[0], { focus: true }); }
        else if (e.key === 'End') { e.preventDefault(); select(cards[cards.length - 1], { focus: true }); }
      });
    });

    // Deep link from pre-landers: ?plan=90|60|30
    const qp = new URLSearchParams(window.location.search).get('plan');
    if (qp && PLAN_PARAM[qp]) {
      const target = cards.find((c) => c.dataset.planKey === PLAN_PARAM[qp]);
      if (target) select(target, { silent: true });
    } else {
      select(current, { silent: true });
    }

    const announce = (msg) => { if (status) { status.textContent = ''; setTimeout(() => { status.textContent = msg; }, 50); } };

    const add = async (type, trigger, heldBags) => {
      if (!window.SMCart) { if (type === 'sub' && form) form.submit(); else if (otp) window.location.href = otp.href; return; }
      const bags = heldBags || +current.dataset.bags;
      try {
        await window.SMCart.addOffer({ type, bags, opener: trigger, busyEl: trigger });
        announce((window.SM.config.strings && window.SM.config.strings.addedToCart) || 'Added to cart');
      } catch (e) { /* SMCart shows the toast and resyncs */ }
    };

    if (form && atc) {
      form.addEventListener('submit', (e) => { e.preventDefault(); add('sub', atc); });
      atc.addEventListener('pointerdown', () => window.SMCart && window.SMCart.prefetch && window.SMCart.prefetch(), { once: true });
    }
    if (otp) otp.addEventListener('click', (e) => { e.preventDefault(); add('otp', otp); });

    // Optional sticky ATC (default off; shown once the offer scrolls out of view)
    if (sticky && atc && 'IntersectionObserver' in window) {
      const btn = sticky.querySelector('[data-sm-sticky-btn]');
      const io = new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        btn.tabIndex = show ? 0 : -1;
      });
      io.observe(root.querySelector('.atcwrap') || root);
      btn.addEventListener('click', () => add('sub', btn));
    }

    // Replay a tap held by the inline script in snippets/sm-offer.liquid (it landed before this file ran).
    if (root.smPending) {
      const held = root.smPending;
      root.smPending = null;
      if (held.trigger) held.trigger.removeAttribute('aria-busy');
      add(held.type, held.trigger || (held.type === 'otp' ? otp : atc), held.bags);
    }

    // Analytics: view_item
    if (window.SM && window.SM.track) {
      window.SM.track('view_item', { value: +current.dataset.total / 100, plan: current.dataset.planKey });
    }
    section.dataset.smOffer = '1';
  };

  const run = () => document.querySelectorAll('[data-sm-offer]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('shopify:block:select', (e) => {
    const card = e.target.closest && e.target.closest('.plan[role="radio"]');
    if (card) card.click();
  });
})();
